var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    style: {
      cursor: "pointer"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M7 4h10l1 2h4v2h-2l-1.5 9a2 2 0 0 1-2 1.7H7.5a2 2 0 0 1-2-1.7L4 8H2V6h4l1-2zM7.8 6l-.6 2h9.6l-.6-2H7.8zM6 8l1.5 9h9L18 8H6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 8,
    height: 2,
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBasket);
export default __webpack_public_path__ + "static/media/deleteBasket.a0f0343b58f176b0dff5dc35b43f6532.svg";
export { ForwardRef as ReactComponent };